const BUDGET_PERIOD_SESSION_PREFIX = 'librattum-selected-budget-period';

const getStorageKey = (userId?: string | null) =>
  userId ? `${BUDGET_PERIOD_SESSION_PREFIX}:${userId}` : BUDGET_PERIOD_SESSION_PREFIX;

export const getSelectedBudgetPeriodId = (userId?: string | null): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage.getItem(getStorageKey(userId));
  } catch {
    return null;
  }
};

export const setSelectedBudgetPeriodId = (
  userId?: string | null,
  periodId?: string | null
): void => {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    const storageKey = getStorageKey(userId);

    if (!periodId) {
      window.sessionStorage.removeItem(storageKey);
      return;
    }

    window.sessionStorage.setItem(storageKey, periodId);
  } catch {
    // sessionStorage pode falhar em ambientes restritos; nesse caso, seguimos sem persistência.
  }
};

export const clearSelectedBudgetPeriodId = (userId?: string | null): void => {
  setSelectedBudgetPeriodId(userId, null);
};
